module.exports = __webpack_public_path__ + "img/e.61886645.png";